import React from 'react';
import { Nav, Button } from 'tabler-react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/brand_logo.svg';
import avatar from '../../assets/ic_account.png';
import store from '../../shared/store';
import Exchange from '../Home/Exchange';
import modal from '../../components/Modal';

const NavLinks = () => (
  <div className="space-between mobile-nav left-nav">
    <Nav>
      <NavLink className="nav-link" exact to="/dashboard">
        <i className="fad fa-home" />
        首页
      </NavLink>
      <NavLink
        className="nav-link"
        RootComponent="a"
        to="/buy?utm_source=dashboard&utm_medium=nav"
        target="_blank">
        <i className="fad fa-shopping-cart" />
        购买续费
      </NavLink>
      {/* <NavLink className="nav-link" to="/dashboard/vas">
        <i className="fe fe-plus-square" />
        增值服务
        <span className="tag-new">NEW</span>
      </NavLink> */}
      {/* <NavLink className="nav-link" to="/dashboard/affiliate">
        <i className="fe fe-credit-card" />
        推荐返现
      </NavLink> */}
      <NavLink
        className="nav-link"
        RootComponent="a"
        to="/download?utm_source=dashboard&utm_medium=nav"
        target="_blank">
        <i className="fad fa-download" />
        应用下载
      </NavLink>
      <NavLink className="nav-link" to="/support" target="_blank">
        <i className="fad fa-life-ring" />
        帮助中心
      </NavLink>
    </Nav>
  </div>
);

export default {
  headerProps: {
    alt: '加速喵',
    href: '/',
    imageURL: logo,
    navItems: (
      <Nav.Item type="div" className="d-none d-md-flex">
        {/* <Button
          icon="box"
          className="card-exchange-btn"
          onClick={() => {
            modal(<Exchange />, { title: '激活卡密' });
          }}>
          激活卡密
        </Button> */}
        <a href="/buy?code=EDUCATION&utm_source=dashboard&utm_medium=card"
          className="edu-badge">
          <i className="ri-coupon-3-fill"></i>
          <span>教育优惠专享</span>
          <i className="ri-arrow-right-s-line"></i>
        </a>
      </Nav.Item>
    ),
    accountDropdown: {
      avatarURL: avatar,
      name: store.user
        ? store.user.email || store.user.displayName || store.user.phone
        : 'Unknown',
      description: store.user ? store.user.userDesc : '',
      options: [
        { icon: 'settings', value: '账号设置', to: '/dashboard/account' },
        {
          icon: 'list',
          value: '历史订单',
          to: '/dashboard/order',
        },
        { icon: 'mail', value: '邮件订阅', to: '/dashboard/subscribe' },
        {
          icon: 'life-buoy',
          value: '我的工单',
          to: `https://api.miaovpn.com/api/loginZendesk?token=${store.user &&
            store.user.token}`,
        },
        { isDivider: true },
        {
          icon: 'help-circle',
          value: '帮助中心',
          to: 'https://miaovpn.com/support',
        },
        {
          icon: 'log-out',
          value: '退出',
          to: '/dashboard/logout',
          onClick: () => {
            store.logout();
            window.location.href = '/dashboard/login';
          },
        },
      ],
    },
  },
  navProps: { children: <NavLinks /> },
};
